// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"7400":"cf8880bf392149d2f08e","7846":"b323e600ed179be1fd21"}[chunkId] + ".js";
};